(ns kyber.kyber-db.content-provider-tag-group)

(def model
  {:ident-key
   :content-provider.tag-group/uuid

   :refs
   {:content-provider.tag-group/values {:model :content-provider.tag
                                        :cardinality :many}}

   :schema
   #:content-provider.tag-group
   {:uuid
    {:doc "UUID of a content provider tag group"}

    :name
    {:doc "Name of the tag group"}

    :description
    {:doc "Description of the tag group"}}})
